/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  ChangePasswordRequest,
  ConfirmEmailRequest,
  ConfirmEmailSetPasswordRequest,
  ExternalAdSignInParams,
  ForgotPasswordRequest,
  HttpValidationProblemDetails,
  ProblemHttpResult,
  ResetPasswordRequest,
  SignInRequest,
  UnauthorizedHttpResult,
  UpdateProfileRequest,
  UserProfileResponse
} from './data.schemas'




export const signIn = (
    segmentationId: number,
    signInRequest: SignInRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/signin`,
      signInRequest,options
    );
  }



export const getSignInMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{segmentationId: number;data: SignInRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{segmentationId: number;data: SignInRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIn>>, {segmentationId: number;data: SignInRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  signIn(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
    export type SignInMutationBody = SignInRequest
    export type SignInMutationError = AxiosError<HttpValidationProblemDetails>

    export const useSignIn = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{segmentationId: number;data: SignInRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof signIn>>,
        TError,
        {segmentationId: number;data: SignInRequest},
        TContext
      > => {

      const mutationOptions = getSignInMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const forgotPassword = (
    segmentationId: number,
    forgotPasswordRequest: ForgotPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/forgotpassword`,
      forgotPasswordRequest,options
    );
  }



export const getForgotPasswordMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{segmentationId: number;data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{segmentationId: number;data: ForgotPasswordRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {segmentationId: number;data: ForgotPasswordRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  forgotPassword(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequest
    export type ForgotPasswordMutationError = AxiosError<HttpValidationProblemDetails>

    export const useForgotPassword = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{segmentationId: number;data: ForgotPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {segmentationId: number;data: ForgotPasswordRequest},
        TContext
      > => {

      const mutationOptions = getForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const resetPassword = (
    segmentationId: number,
    resetPasswordRequest: ResetPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/resetpassword`,
      resetPasswordRequest,options
    );
  }



export const getResetPasswordMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{segmentationId: number;data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{segmentationId: number;data: ResetPasswordRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {segmentationId: number;data: ResetPasswordRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  resetPassword(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = AxiosError<HttpValidationProblemDetails>

    export const useResetPassword = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{segmentationId: number;data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {segmentationId: number;data: ResetPasswordRequest},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getProfile = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserProfileResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/profile`,options
    );
  }


export const getGetProfileQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/user/profile`] as const;
    }

    
export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<UnauthorizedHttpResult>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = AxiosError<UnauthorizedHttpResult>

export const useGetProfile = <TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<UnauthorizedHttpResult>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProfileQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetProfile = async <TData = Awaited<ReturnType<typeof getProfile>>, TError = AxiosError<UnauthorizedHttpResult>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProfileQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const updateProfile = (
    segmentationId: number,
    updateProfileRequest: UpdateProfileRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/profile`,
      updateProfileRequest,options
    );
  }



export const getUpdateProfileMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{segmentationId: number;data: UpdateProfileRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{segmentationId: number;data: UpdateProfileRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {segmentationId: number;data: UpdateProfileRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  updateProfile(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateProfileRequest
    export type UpdateProfileMutationError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>

    export const useUpdateProfile = <TError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{segmentationId: number;data: UpdateProfileRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {segmentationId: number;data: UpdateProfileRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const externalAdSignIn = (
    segmentationId: number,
    params: ExternalAdSignInParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/externaladsignin`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getExternalAdSignInQueryKey = (segmentationId: number,
    params: ExternalAdSignInParams,) => {
    return [`/api/segment/${segmentationId}/user/externaladsignin`, ...(params ? [params]: [])] as const;
    }

    
export const getExternalAdSignInQueryOptions = <TData = Awaited<ReturnType<typeof externalAdSignIn>>, TError = AxiosError<unknown>>(segmentationId: number,
    params: ExternalAdSignInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalAdSignIn>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExternalAdSignInQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalAdSignIn>>> = ({ signal }) => externalAdSignIn(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalAdSignIn>>, TError, TData> & { queryKey: QueryKey }
}

export type ExternalAdSignInQueryResult = NonNullable<Awaited<ReturnType<typeof externalAdSignIn>>>
export type ExternalAdSignInQueryError = AxiosError<unknown>

export const useExternalAdSignIn = <TData = Awaited<ReturnType<typeof externalAdSignIn>>, TError = AxiosError<unknown>>(
 segmentationId: number,
    params: ExternalAdSignInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalAdSignIn>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getExternalAdSignInQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const externalSignInCallBack = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/user/signincallback`,options
    );
  }


export const getExternalSignInCallBackQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/user/signincallback`] as const;
    }

    
export const getExternalSignInCallBackQueryOptions = <TData = Awaited<ReturnType<typeof externalSignInCallBack>>, TError = AxiosError<void>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalSignInCallBack>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExternalSignInCallBackQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalSignInCallBack>>> = ({ signal }) => externalSignInCallBack(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalSignInCallBack>>, TError, TData> & { queryKey: QueryKey }
}

export type ExternalSignInCallBackQueryResult = NonNullable<Awaited<ReturnType<typeof externalSignInCallBack>>>
export type ExternalSignInCallBackQueryError = AxiosError<void>

export const useExternalSignInCallBack = <TData = Awaited<ReturnType<typeof externalSignInCallBack>>, TError = AxiosError<void>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalSignInCallBack>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getExternalSignInCallBackQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const logout = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/user/logout`,undefined,options
    );
  }



export const getLogoutMutationOptions = <TError = AxiosError<UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
          

          return  logout(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>
    
    export type LogoutMutationError = AxiosError<UnauthorizedHttpResult>

    export const useLogout = <TError = AxiosError<UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const confirmEmail = (
    confirmEmailRequest: ConfirmEmailRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/user/confirmemail`,
      confirmEmailRequest,options
    );
  }



export const getConfirmEmailMutationOptions = <TError = AxiosError<ProblemHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmail>>, TError,{data: ConfirmEmailRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmEmail>>, TError,{data: ConfirmEmailRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEmail>>, {data: ConfirmEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmEmail(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEmailMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEmail>>>
    export type ConfirmEmailMutationBody = ConfirmEmailRequest
    export type ConfirmEmailMutationError = AxiosError<ProblemHttpResult>

    export const useConfirmEmail = <TError = AxiosError<ProblemHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmail>>, TError,{data: ConfirmEmailRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof confirmEmail>>,
        TError,
        {data: ConfirmEmailRequest},
        TContext
      > => {

      const mutationOptions = getConfirmEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const confirmEmailSetPassword = (
    confirmEmailSetPasswordRequest: ConfirmEmailSetPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/user/confirmemailsetpassword`,
      confirmEmailSetPasswordRequest,options
    );
  }



export const getConfirmEmailSetPasswordMutationOptions = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailSetPassword>>, TError,{data: ConfirmEmailSetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof confirmEmailSetPassword>>, TError,{data: ConfirmEmailSetPasswordRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEmailSetPassword>>, {data: ConfirmEmailSetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmEmailSetPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEmailSetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEmailSetPassword>>>
    export type ConfirmEmailSetPasswordMutationBody = ConfirmEmailSetPasswordRequest
    export type ConfirmEmailSetPasswordMutationError = AxiosError<HttpValidationProblemDetails>

    export const useConfirmEmailSetPassword = <TError = AxiosError<HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailSetPassword>>, TError,{data: ConfirmEmailSetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof confirmEmailSetPassword>>,
        TError,
        {data: ConfirmEmailSetPasswordRequest},
        TContext
      > => {

      const mutationOptions = getConfirmEmailSetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const changePassword = (
    changePasswordRequest: ChangePasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.put(
      `/api/user/password`,
      changePasswordRequest,options
    );
  }



export const getChangePasswordMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: ChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordRequest
    export type ChangePasswordMutationError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>

    export const useChangePassword = <TError = AxiosError<HttpValidationProblemDetails | UnauthorizedHttpResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: ChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getChangePasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    